import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Modified")
const _hoisted_2 = { class: "c-title f-md t-left px-24" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Take Profit")
const _hoisted_4 = { class: "pull-right" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Stop Loss")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_TheTradeLimitDisplay = _resolveComponent("TheTradeLimitDisplay")
  const _component_ResultDialogTemplate = _resolveComponent("ResultDialogTemplate")

  return (_openBlock(), _createBlock(_component_ResultDialogTemplate, null, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "symbol_39" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode("p", _hoisted_2, [
        _createVNode(_component_t, {
          path: "symbol_40",
          class: "mr-6 f-md"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_TheTradeLimitDisplay, {
          class: "c-text f-medium",
          value: _ctx.top
        }, null, 8, ["value"]),
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_t, {
            path: "symbol_41",
            class: "mr-6 f-md"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_TheTradeLimitDisplay, {
            class: "c-text f-medium",
            value: _ctx.bottom
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _: 1
  }))
}